import FluidImage from '@utility/FluidImage';
import PortableText from '@utility/PortableText';
import ScrollInView from '@utility/ScrollInView';
import React from 'react';
import PropTypes from 'prop-types';

const Bio = ({ data: { image, name, role, description } }) => (
  <ScrollInView>
    <div className="wrapper">
      <div className="row">
        <div className="col-6 offset-3 md:col-2 md:offset-1 md-down:mb-6">
          <div className="w-full bg-mono-100 rounded-full overflow-hidden isolate">
            <FluidImage src={image} maxWidth={354} maxHeight={354} />
          </div>
        </div>
        <div className="col-12 md:col-8">
          <h2 className="type-sans-240">{name}</h2>
          {role && <p className="type-sans-230">{role}</p>}
          <div className="richtext-content mt-4 type-sans-430">
            <PortableText blocks={description.richText} />
          </div>
        </div>
      </div>
    </div>
  </ScrollInView>
);

Bio.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    role: PropTypes.string,
    description: PropTypes.shape({
      richText: PropTypes.array,
    }).isRequired,
  }),
};

Bio.defaultProps = {
  data: {
    image: {},
    name: '',
    role: '',
    description: {},
  },
};

export default Bio;
